import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IdentifierDTO, PrimaryButton, useModal } from '@zazume/zzm-base';
import { FC } from 'react';
import { RequestUnitServiceUpgradeModal } from '../../../components/modal/RequestUnitServiceUpgrade/RequestUnitServiceUpgrade.modal';
import { useGet } from '../../../hooks';
import { useI18n } from '../../../hooks/useI18n';
import { API } from '../../../lib/network/API';
import { OwnerServiceContract } from '#/domain/ownerServiceContract/OwnerServiceContract';
import { ManagementService } from '#/domain/ownerServiceContract/ManagementService';
import { OwnerServiceContractKeys } from '#/hooks/api/ownerServiceContract.keys';

const GoldenPrimary = styled(PrimaryButton)(({ theme }) => css`
  background: ${theme.colors.Mostard};
  color: ${theme.colors.Black};

  &:hover {
    /* TODO: Create mostard semi dark ????? */
    background: #f5c000 !important;
  }
`);

interface Props {
  ownerAccountId: IdentifierDTO;
}

export const CommercializationUpgradeButton: FC<Props> = ({ ownerAccountId }) => {
  const { t } = useI18n();
  const { RenderModal: RenderServiceModal, open: openServiceModal } = useModal({ modalSize: 'm' });
  const { data: activeOwnerServiceContracts = [], isLoading } = useGet<OwnerServiceContract<ManagementService>[]>(
    OwnerServiceContractKeys.findAllActiveByOwnerAccountId(ownerAccountId),
    API.ownerServiceContract.management.findAllActiveByOwnerAccountId(ownerAccountId));

  if (isLoading || activeOwnerServiceContracts.length !== 0) {
    return null;
  }

  return (
    <>
      <GoldenPrimary onClick={openServiceModal}>{t('modals.requestServiceUpgrade.title')}</GoldenPrimary>
      <RenderServiceModal>
        <RequestUnitServiceUpgradeModal/>
      </RenderServiceModal>
    </>
  );
};
